<template src="../templates/wrappers/free-delivery-notify.html"></template>

<script>
export default {
  name: 'FreeDeliveryNotify',
  props: {
    minCount: {
      type: [Number, null],
      default: () => 0,
    },
    currentCount: {
      type: Number,
      default: () => 0,
    },
    isFree: Boolean,
  },
  computed: {
    countToFreeDelivery() {
      return this.minCount - this.currentCount;
    },
    percToFreeDelivery() {
      const ref = this.currentCount / this.minCount;
      return ref * 100;
    },
  },
  mounted() {
    document.addEventListener('scroll', () => {
      const elems = document.getElementsByClassName('product-progress-container');
      if (elems[0]) {
        const elem = elems[0];
        if (elem.offsetTop > 0) {
          elem.classList.add('on-shadow');
        } else {
          elem.classList.remove('on-shadow');
        }
      }
    });
  },
};
</script>
